let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8BT92")).then(() => parcelRequire('39EXX'));